(function () {
	if (window.__sovModalCoreLoaded === true) {
		return;
	}
	window.__sovModalCoreLoaded = true;

	var activeOverlay = null;
	var lastFocus = null;
	var prevBodyOverflow = '';

	function gtagSafe(name, params) {
		params = params || {};

		if (typeof window.gtag === 'function') {
			try {
				window.gtag('event', name, params);
			} catch (e) {}
			return;
		}

		if (Array.isArray(window.dataLayer)) {
			try {
				window.dataLayer.push(Object.assign({ event: name }, params));
			} catch (e) {}
		}
	}

	function dispatch(name, detail) {
		try {
			window.dispatchEvent(new CustomEvent(name, { detail: detail }));
		} catch (e) {}
	}

	function lockScroll() {
		prevBodyOverflow = document.body.style.overflow || '';
		document.body.style.overflow = 'hidden';
	}

	function unlockScroll() {
		document.body.style.overflow = prevBodyOverflow || '';
		prevBodyOverflow = '';
	}

	function isCoreOverlay(el) {
		return !!el && el.getAttribute && el.getAttribute('data-sov-modal-core') === '1';
	}

	function getKeyFromTrigger(el) {
		if (!el || !el.classList) return '';
		for (var i = 0; i < el.classList.length; i++) {
			var cls = el.classList[i];
			if (cls && cls.indexOf('sov-open-') === 0) {
				return cls.substring(9);
			}
		}
		return '';
	}

	function findTriggerRoot(target) {
		var el = target;
		while (el && el !== document.documentElement) {
			if (el.classList) {
				for (var i = 0; i < el.classList.length; i++) {
					var cls = el.classList[i];
					if (cls && cls.indexOf('sov-open-') === 0) {
						return el;
					}
				}
			}
			el = el.parentElement;
		}
		return null;
	}

	function findOverlayByKey(key) {
		if (!key) return null;
		var id = 'sov-modal-' + key + '-overlay';
		var ov = document.getElementById(id);
		if (isCoreOverlay(ov)) return ov;
		return null;
	}

	function setExpandedForOverlay(ov, expanded) {
		if (!ov || !ov.id) return;
		var sel = '[aria-haspopup="dialog"][aria-controls="' + ov.id + '"]';
		document.querySelectorAll(sel).forEach(function (t) {
			t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		});
	}

	function getTelemetryPayload(overlay, reason) {
		if (!overlay) return {};
		return {
			overlay_id: overlay.id || '',
			reason: reason || '',
			product_id: overlay.getAttribute('data-sov-product-id') || '',
			product_handle: overlay.getAttribute('data-sov-product-handle') || '',
			variant_id: overlay.getAttribute('data-sov-variant-id') || ''
		};
	}

	function openOverlay(overlay) {
		if (!isCoreOverlay(overlay)) return;

		if (activeOverlay && activeOverlay !== overlay) {
			closeOverlay(activeOverlay, 'switch');
		}

		activeOverlay = overlay;
		lastFocus = document.activeElement;

		overlay.classList.add('active');
		overlay.setAttribute('aria-hidden', 'false');
		setExpandedForOverlay(overlay, true);
		lockScroll();

		var key = overlay.getAttribute('data-sov-modal-key') || '';
		gtagSafe(key + '_modale_open', getTelemetryPayload(overlay, ''));

		dispatch('sov:modal:opened', { key: key, overlay_id: overlay.id || '' });

		var closeBtn = overlay.querySelector('.sov-modal-close') || overlay.querySelector('.sov-modal-close-mobile');
		if (closeBtn && typeof closeBtn.focus === 'function') {
			try {
				closeBtn.focus();
			} catch (e) {}
		}
	}

	function closeOverlay(overlay, reason) {
		if (!isCoreOverlay(overlay)) return;

		overlay.classList.remove('active');
		overlay.setAttribute('aria-hidden', 'true');
		setExpandedForOverlay(overlay, false);
		unlockScroll();

		var key = overlay.getAttribute('data-sov-modal-key') || '';
		gtagSafe(key + '_modale_close', getTelemetryPayload(overlay, reason || 'user'));

		dispatch('sov:modal:closed', {
			key: key,
			overlay_id: overlay.id || '',
			reason: reason || 'user'
		});

		if (lastFocus && typeof lastFocus.focus === 'function') {
			try {
				lastFocus.focus();
			} catch (e) {}
		}
		lastFocus = null;

		if (activeOverlay === overlay) {
			activeOverlay = null;
		}
	}

	document.addEventListener(
		'click',
		function (ev) {
			var openRoot = findTriggerRoot(ev.target);
			if (openRoot) {
				var key = getKeyFromTrigger(openRoot);
				var overlay = findOverlayByKey(key);
				if (overlay) {
					ev.preventDefault();
					ev.stopPropagation();
					openOverlay(overlay);
				}
				return;
			}

			var closeBtn = ev.target.closest('.sov-modal-close, .sov-modal-close-mobile');
			if (closeBtn) {
				ev.preventDefault();
				var ov1 = closeBtn.closest('.sov-modal-overlay');
				if (isCoreOverlay(ov1)) closeOverlay(ov1, 'button');
				return;
			}

			var ov2 = ev.target && ev.target.classList && ev.target.classList.contains('sov-modal-overlay') ? ev.target : null;
			if (isCoreOverlay(ov2)) {
				ev.preventDefault();
				closeOverlay(ov2, 'backdrop');
			}
		},
		{ passive: false }
	);

	document.addEventListener(
		'keydown',
		function (ev) {
			if (ev.key === 'Escape') {
				if (activeOverlay && isCoreOverlay(activeOverlay)) {
					ev.preventDefault();
					closeOverlay(activeOverlay, 'escape');
				}
				return;
			}

			if (ev.key !== 'Enter' && ev.key !== ' ') return;

			var openRoot = findTriggerRoot(ev.target);
			if (!openRoot) return;

			var key = getKeyFromTrigger(openRoot);
			var overlay = findOverlayByKey(key);
			if (!overlay) return;

			ev.preventDefault();
			openOverlay(overlay);
		},
		true
	);

	window.SovModalCore = window.SovModalCore || {};

	window.SovModalCore.openByKey = function (key) {
		var overlay = findOverlayByKey(key);

		if (!overlay) {
			return false;
		}

		openOverlay(overlay);
		return true;
	};

	window.SovModalCore.closeByKey = function (key, reason) {
		var overlay = findOverlayByKey(key);

		if (!overlay) {
			return false;
		}

		closeOverlay(overlay, reason || 'api');
		return true;
	};

	window.SovModalCore.openById = function (id) {
		var overlay = document.getElementById(id);

		if (!isCoreOverlay(overlay)) {
			return false;
		}

		openOverlay(overlay);
		return true;
	};

	window.SovModalCore.closeById = function (id, reason) {
		var overlay = document.getElementById(id);

		if (!isCoreOverlay(overlay)) {
			return false;
		}

		closeOverlay(overlay, reason || 'api');
		return true;
	};



})();